import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../../context/AuthContext';
import { getDefaultHomePath } from '../../utils/HomeNavigation';

const PublicRoute = ({ children }) => {
  const { accessToken, authReady } = useContext(AuthContext);

  // Todavía restaurando la sesión desde el storage seguro (async) — no decidir
  // la ruta con esto, o cada arranque de la app flashea la pantalla de login.
  if (!authReady) return null;

  return accessToken ? <Navigate to={getDefaultHomePath()} /> : children;
};

export default PublicRoute;
